import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';

import RangeField from 'components/RangeField';
import { IExpandedMailingRule } from 'interfaces/MailingRule';

import { IMailingRuleSubformProps } from '../../interfaces';

const SubFormCountAndSumRanges: React.FC<IMailingRuleSubformProps> = ({
  isEditable,
}: IMailingRuleSubformProps) => {
  const { values } = useFormikContext<IExpandedMailingRule>();

  const isAggregatedByCustomer = values.aggregationType === 'CUSTOMER';

  return (
    <React.Fragment>
      {isAggregatedByCustomer && (
        <Grid
          data-cy="sub-form-count-and-sum-ranges__container--customer-debts-sum"
          item
          xs={12}
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item xs={12}>
            <Typography variant="h6">Valor da Dívida do Cliente</Typography>
          </Grid>
          <Grid
            data-cy="sub-form-count-and-sum-ranges__range-field--customer-debts-sum"
            item
            xs={12}
          >
            <RangeField
              name="customerDebtsSum"
              isMoney
              disabled={!isEditable}
            />
          </Grid>
        </Grid>
      )}

      <Grid
        data-cy="sub-form-count-and-sum-ranges__container--contract-debts-sum"
        item
        xs={12}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Typography variant="h6">Valor da Dívida por contrato</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          data-cy="sub-form-count-and-sum-ranges__range-field--contract-debts-sum"
        >
          <RangeField name="contractDebtsSum" isMoney disabled={!isEditable} />
        </Grid>
      </Grid>

      {isAggregatedByCustomer && (
        <Grid
          data-cy="sub-form-count-and-sum-ranges__container--customer-contracts-sum"
          item
          xs={12}
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid item xs={12}>
            <Typography variant="h6">
              Quantidade de contratos por cliente
            </Typography>
          </Grid>
          <Grid
            data-cy="sub-form-count-and-sum-ranges__range-field--customer-contracts-sum"
            item
            xs={12}
          >
            <RangeField
              name="customerContractsSum"
              disabled={!isEditable}
              labelAfter=""
            />
          </Grid>
        </Grid>
      )}

      <Grid
        data-cy="sub-form-count-and-sum-ranges__container--contract-invoices-sum"
        item
        xs={12}
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12}>
          <Typography variant="h6">
            Quantidade de faturas por contratos
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          data-cy="sub-form-count-and-sum-ranges__range-field--contract-invoices-sum"
        >
          <RangeField
            name="contractInvoicesSum"
            disabled={!isEditable}
            labelAfter=""
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default SubFormCountAndSumRanges;
